import axios from '@axios';

export default class SLSEstoqueClient {
  async consultarEstoque(itemIds, tipoPedidoId = null) {
    const body = { itemIds };
    if (tipoPedidoId) body.tipoPedidoId = tipoPedidoId;
    const { data } = await axios.post('estoque/consultar', body);
    return data;
  }

  async importarCsv(file) {
    const form = new FormData();
    form.append('file', file);
    const { data } = await axios.post('estoque/importar-csv', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  }
}
